export default __webpack_public_path__ + "static/media/pineapple_alone.5e47657b.png";